<div class="dashboard-filters">
    <div class="dashboard-filters-row">
        <app-multi-select-v2 class="filters-all" (optionOnSelection)="tablesFiltersChange($event)" [pageFilters]="pageFilters"> </app-multi-select-v2>
    </div>
    <app-view-filters-multi-select [pageFilters]="pageFilters"></app-view-filters-multi-select>
</div>
